/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ForecastModelAggregationLevelReport'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./ForecastModelAggregationLevelReport'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.ForecastModelReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.ForecastModelAggregationLevelReport);
  }
}(this, function(ApiClient, ForecastModelAggregationLevelReport) {
  'use strict';




  /**
   * The ForecastModelReport model module.
   * @module model/ForecastModelReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>ForecastModelReport</code>.
   * @alias module:model/ForecastModelReport
   * @class
   */
  var exports = function() {
    var _this = this;












  };

  /**
   * Constructs a <code>ForecastModelReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ForecastModelReport} obj Optional instance to populate.
   * @return {module:model/ForecastModelReport} The populated <code>ForecastModelReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Levels')) {
        obj['Levels'] = ApiClient.convertToType(data['Levels'], [ForecastModelAggregationLevelReport]);
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('StartDate')) {
        obj['StartDate'] = ApiClient.convertToType(data['StartDate'], 'Date');
      }
      if (data.hasOwnProperty('EndDate')) {
        obj['EndDate'] = ApiClient.convertToType(data['EndDate'], 'Date');
      }
      if (data.hasOwnProperty('RollingPeriod')) {
        obj['RollingPeriod'] = ApiClient.convertToType(data['RollingPeriod'], 'Boolean');
      }
      if (data.hasOwnProperty('RollingHistoryMonths')) {
        obj['RollingHistoryMonths'] = ApiClient.convertToType(data['RollingHistoryMonths'], 'Integer');
      }
      if (data.hasOwnProperty('DimensionID')) {
        obj['DimensionID'] = ApiClient.convertToType(data['DimensionID'], 'Integer');
      }
      if (data.hasOwnProperty('AutoAggregation')) {
        obj['AutoAggregation'] = ApiClient.convertToType(data['AutoAggregation'], 'Boolean');
      }
      if (data.hasOwnProperty('OwnerID')) {
        obj['OwnerID'] = ApiClient.convertToType(data['OwnerID'], 'Integer');
      }
      if (data.hasOwnProperty('CreatorID')) {
        obj['CreatorID'] = ApiClient.convertToType(data['CreatorID'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Array.<module:model/ForecastModelAggregationLevelReport>} Levels
   */
  exports.prototype['Levels'] = undefined;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Date} StartDate
   */
  exports.prototype['StartDate'] = undefined;
  /**
   * @member {Date} EndDate
   */
  exports.prototype['EndDate'] = undefined;
  /**
   * @member {Boolean} RollingPeriod
   * @default false
   */
  exports.prototype['RollingPeriod'] = false;
  /**
   * @member {Integer} RollingHistoryMonths
   */
  exports.prototype['RollingHistoryMonths'] = undefined;
  /**
   * @member {Integer} DimensionID
   * @default 0
   */
  exports.prototype['DimensionID'] = 0;
  /**
   * @member {Boolean} AutoAggregation
   * @default false
   */
  exports.prototype['AutoAggregation'] = false;
  /**
   * @member {Integer} OwnerID
   * @default 0
   */
  exports.prototype['OwnerID'] = 0;
  /**
   * @member {Integer} CreatorID
   * @default 0
   */
  exports.prototype['CreatorID'] = 0;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


